import styled from 'styled-components';
import { BLACK, CRIMSON_700 } from '@styles/colors';
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 100%;
  flex: 1;
  padding: 16px 12px 24px 12px;
  background-color: white;
  justify-content: space-between;
  padding-bottom: ${safeAreaInset().bottom * 2 || 24}px;
`;

export const Title = styled.p`
  font-size: 13px;
  color: ${BLACK};
  font-weight: 400;
  margin: 1vh 0 0 0;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const Description = styled.p`
  font-size: 13px;
  color: ${BLACK};
  text-align: center;
  margin: 4vh 0 4vh 0;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const ErrorMessage = styled.p`
  color: ${CRIMSON_700};
  font-size: 13px;
  text-align: center;
  margin: 2vh 0 0 0;
`;

export const PinContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;
